import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leagues',
  templateUrl: './leagues.component.html',
  styleUrls: ['./leagues.component.scss']
})
export class LeagueSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
